import React from 'react';

export const DataEmpty = ({ colSpan }) => {
	return (
		<tr>
			<td colSpan={colSpan}>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '100px',
						color: 'rgba(0,0,0,0.2)',
					}}>
					No Data
				</div>
			</td>
		</tr>
	);
};
